import { DAIMI_IS_INTRO, DAIMI_IS_SLUG } from '@/content/daimiInsurance'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The thirtieth report with a designed page of its own, and the fifteenth focus cut
  // to arrive with both of its figures — asked for on 2026-08-28 in the same words as
  // the Logistics and Manufacturing cuts before it (*"referans alarak ilgili sayfayı
  // birebir tıpa tıp aynısını tasarla"*) with a four-part full-page capture of the
  // live page, the cover as two overlapping 2000px crops, Figure 1 and the report
  // mockup. See `content/daimiInsurance.ts` and `pages/DaimiInsurance.tsx`. Not to be
  // confused with the Future 2030 Insurance outlook further down, which is a separate
  // report on `'insurance-outlook'`.
  ...focus(
    DAIMI_IS_SLUG,
    'Insurance',
    'daimi-report-2026-insurance-cover',
    '7a4628b5-1f14-455f-b62b-0325668f22f0-digitopia-daimi-2026-report-insurance.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held on
  // the page that says them — so the search result and the page cannot drift apart.
  // `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_IS_INTRO.body,
  layout: 'insurance-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiInsuranceChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 10
